import $ from 'jquery';
import 'slick-carousel';

/**
 * NewsTeaser Class
 * @class NewsTeaser
 */

export default class NewsTeaser {
    slick;
    slider;
    constructor() {
        this.checkIfSliderNeeded();
        this.loadEvents();
    }

    loadEvents() {
        window.addEventListener('resize', () => {
            this.checkIfSliderNeeded();
        })
    }

    checkIfSliderNeeded() {
        if (window.matchMedia("(min-width: 768px)").matches && this.slick) {
            this.destroySlider();
        } else if (window.matchMedia("(max-width: 767px)").matches && !this.slick) {
            this.loadSlider();
        }
    }

    destroySlider() {
        $('.news-teaser__wrapper').slick('unslick');
        this.slick = undefined;
    }

    loadSlider() {
        this.slick = $('.news-teaser__wrapper').slick({
            infinite: false,
            arrows: false,
            slidesToShow: 1.15,
            slidesToScroll: 1
        });
    }

}
